module.exports = __webpack_public_path__ + "media/夢裡面的我們在一起很久很久.607ef323.mp3";